<template>
  <el-dialog
      title="链接释放详情"
      :visible.sync="visible"
      width="780px"
      append-to-body
      @open="loadData">
    <w-table
        v-loading="loading"
        :columns="columns"
        :table-data="rows"
        :isUseInnerPage="true"
        :isPagination="true"
        :isUseInnerSearch="true">
      <!-- HDD 释放详情 -->
<!--      <div slot="hddDetail" slot-scope="{text, record}">-->
<!--        <div class="rel-row"><span class="rel-lbl">寄送时间：</span><span>{{ record.hddInfo?.issuedTime || 'NA' }}</span></div>-->
<!--        <div class="rel-row"><span class="rel-lbl">快递单号：</span><span>{{ record.hddInfo?.courierNo || 'NA' }}</span></div>-->
<!--        <div class="rel-row"><span class="rel-lbl">硬盘：</span><span>{{ getHddType(record.hddInfo?.hddType) }}</span></div>-->
<!--        <div class="rel-row"><span class="rel-lbl">硬盘大小：</span><span>{{ record.hddInfo?.numberOrSize || 'NA' }}</span></div>-->
<!--        <div class="rel-row"><span class="rel-lbl">收件人：</span><span>{{ record.hddInfo?.receiverName || 'NA' }}</span></div>-->
<!--      </div>-->
      <!-- LINK 释放详情 -->
      <div slot="linkDetail" slot-scope="{text, record}">
        <div class="rel-row"><span class="rel-lbl">释放时间：</span><span>{{ record.createTime || 'NA' }}</span></div>
        <div class="rel-row"><span class="rel-lbl">失效时间：</span><span>{{ record.linkInfo?.expirationTime || 'NA' }}</span></div>
        <div class="rel-row"><span class="rel-lbl">状态：</span>
          <span v-if="record?.linkInfo?.hasOwnProperty('expired') ">
          <span class="rel-warn" v-if="record.linkInfo.expired">已失效<span v-if="! record.linkInfo.expirationTime">且已清空</span></span>
          <span class="rel-ok" v-else>生效中</span>
          </span>
          <span class="rel-warn" v-else>已失效</span>
        </div>
      </div>
      <template slot="operation" slot-scope="{text,record}">
        <el-button
            size="mini"
            type="success"
            @click="handleRawData(record)">下载原始数据
        </el-button>
      </template>
    </w-table>
    <l-e-down-files-dialog v-if="downRawFilesDialog" :show-dialog.sync="downRawFilesDialog"
                           :downLoadUrl="downLoadRawUrl">
    </l-e-down-files-dialog>
    <l-e-down-files-volcano-dialog v-if="downRawFilesVolcanoDialog" :show-dialog.sync="downRawFilesVolcanoDialog"
                                   :downLoadUrl="downLoadRawUrl">
    </l-e-down-files-volcano-dialog>
  </el-dialog>
</template>

<script>
import {getRawReleaseInfoByProjectSoleKey} from "@/api/dilivery";

export default {
  name: 'RawReleaseDialog',
  props: {
    showDialog: {type: Boolean, default: false},
    selectDetail: {type: Object, default: () => ({})}
  },
  data() {
    return {
      loading: false,
      rows: [],
      columns: [
        {title: '合同号', dataIndex: 'contractNo', key: 'contractNo', width: 160, scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}},
        {title: '类型', dataIndex: 'projectType', key: 'projectType', width: 120, scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}},
        // {title: 'HDD释放', dataIndex: 'hddDetail', key: 'hddDetail', scopedSlots: {customRender: 'hddDetail'}},
        {title: '链接释放', dataIndex: 'linkDetail', key: 'linkDetail', scopedSlots: {customRender: 'linkDetail'}},
        {title: '操作', dataIndex: 'operation', key: 'operation', scopedSlots: {customRender: 'operation'}}
      ],
      downRawFilesDialog: false,
      downRawFilesVolcanoDialog: false,
      downLoadRawUrl: ''
    }
  },
  computed: {
    visible: {
      get() { return this.showDialog },
      set(val) { this.$emit('update:showDialog', val) }
    },
    // 组内有链接释放的项目
    linkRows() {
      const projects = Array.isArray(this.selectDetail?.projectInfoList) ? this.selectDetail.projectInfoList : []
      return projects.filter(p => this.projectTypes(p).includes('ONLINE'))
    }
  },
  methods: {
    projectTypes(p) {
      if (Array.isArray(p?.releaseTypes)) return p.releaseTypes
      return p?.isHdd ? ['HDD'] : ['ONLINE']
    },
    getHddType(hddWay) {
      const map = {
        'HDD_BUY': '公司硬盘（客户购买）',
        'HDD_BORROW': '公司硬盘（借用）',
        'HDD_OWN': '客户硬盘'
      }
      return map[hddWay] || 'NA'
    },
    // 打开弹框时重新请求链接释放详情
    async loadData() {
      const list = this.linkRows
      // HDD 为合并组信息，直接用记录上的 rawInfo；LINK 按项目重新请求
      // const hddInfo = this.selectDetail?.rawInfo || {}
      // const keys = list.map(p => p.projectSoleKey || p.id).filter(k => k != null)
      if (!list.length) {
        // this.rows = list.map(p => ({...p, hddInfo, linkInfo: {}}))
        return
      }
      this.loading = true
      try {
        const sendData = list.map(item => ({projectSoleKey: item.projectSoleKey, isHdd: item.isHdd, rawLink:item.rawLink}))
        const res = await getRawReleaseInfoByProjectSoleKey(sendData)
        const dataMap = res?.data || {}
        this.rows = list.map(p => {
          const key = p.projectSoleKey
          return {...p, hddInfo:dataMap[key].HDD||{}, linkInfo: dataMap[key].LINK || {}}
        })
      } catch (e) {
        console.error('获取链接释放详情失败：', e)
        this.rows = list.map(p => ({...p, hddInfo:{}, linkInfo: {}}))
      } finally {
        this.loading = false
      }
    },
    // 原始数据
    handleRawData(record) {
      this.downLoadRawUrl = record.rawLink
      if (record?.isRawCloud) {
        this.downRawFilesVolcanoDialog = true
      } else {
        this.downRawFilesDialog = true
      }
    },
  }
}
</script>

<style scoped>
.rel-row {
  line-height: 20px;
  font-size: 13px;
  color: #66c03b;
}
.rel-lbl {
  color: #66c03b;
}
.rel-ok {
  color: #66c03b;
}
.rel-warn {
  color: #d54444;
}
</style>
